'use strict';

var _require = require('./baseProperties'),
    baseProperties = _require.baseProperties;

module.exports.PatentSchema = {
  title: 'Patent',
  type: 'object',
  properties: Object.assign({}, baseProperties, {
    datumDerPrioritaetsbegruendendenErstanmeldung: {
      type: 'string',
      format: 'date-time'
    }
  })
};


//////////////////
// WEBPACK FOOTER
// ./~/fobclient/lib/schema/patent.js
// module id = Z/GO
// module chunks = 0